"use client";

import { useTranslations } from "next-intl";
import FaqAccordion from "./faq-accordion";

export default function VideoDosyalari() {
    const t = useTranslations("helpContent");

    return (
        <FaqAccordion
            items={[
                { question: t("videoQ1"), answer: t("videoA1") },
                { question: t("videoQ2"), answer: t("videoA2") },
                { question: t("videoQ3"), answer: t("videoA3") },
            ]}
        />
    );
}
